import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import type { AmountSourceConditionType } from 'app-components/flux/transaction-rules/transactionRulesTypes';

import { makeStyles } from 'tss-react/mui';
import usePrivacyMaskValue from 'app-components/hooks/privacyMode/usePrivacyMaskValue';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
}));

const AmountSource = ({ amount }: { amount?: AmountSourceConditionType }) => {
  const { classes } = useStyles();

  const privacyModeMask = usePrivacyMaskValue();

  if (!amount) {
    return <></>;
  }

  return (
    <>
      {amount && amount.amount1 && (
        <Box className={classes.row}>
          <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
            Amount is
          </Typography>
          <Typography className={classes.textPaddingAfter} variant='bodyMedium'>
            {`an ${amount.amount1 < 0 ? 'Expense' : 'Income'} `}
            {amount.amountMatchingOperator.toLowerCase().replace('_', ' ')} $
            {privacyModeMask(String(Math.abs(amount.amount1)))}
          </Typography>
          {amount.amountMatchingOperator === 'BETWEEN' && amount.amount2 && (
            <Typography variant='bodyMedium'> and ${privacyModeMask(String(Math.abs(amount.amount2)))}</Typography>
          )}
        </Box>
      )}
    </>
  );
};

export default AmountSource;
